<template>
  <div class="main notMemberPaymentMain">
    <!-- 顶部 -->
    <div class="title">
      <img class="blueCircle" src="../assets/blueCircle.png" />
      <span class="text">缴费凭证</span>
      <el-button type="primary" @click="addPayment" style="margin-left: 78%;">添加</el-button>
    </div>

    <!-- 内容主体 -->
    <div class="table">
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 99%;height: 530px;overflow-y: scroll;"
        :header-row-style="{color: '#666'}"
      >
        <el-table-column align="center" prop="orderNumber" label="序号" type="index" :index="increamentIndex" width="100"></el-table-column>
        <el-table-column align="center" prop="companyname" label="会员单位"></el-table-column>
        <el-table-column align="center" prop="year" label="缴费年份"></el-table-column>
        <el-table-column align="center" prop="amount" label="缴费金额"></el-table-column>
        <el-table-column align="center" prop="paydate" label="缴费日期"></el-table-column>
        <el-table-column align="center" prop="state" label="是否处理"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as Cache from '../utils/cache'
import * as API from '../utils/apiService'

export default {
  data () {
    return {
      id: '', // 表格id
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      state: '' // // 待处理 0  已处理 1
    }
  },
  mounted () {
    this.asyncFindOneInfo()
    this.asyncGetPayment()
  },
  methods: {
    // 序号自增
    increamentIndex (index) {
      return index + (this.currentPage - 1) * this.pageSize + 1
    },
    asyncFindOneInfo () {
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.findOneInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          if (!resp.data || (resp.data && resp.data.status === '3')) {
            this.$message.error('请先填写申请信息')
            this.$router.push('/notMemberMiddleWare')
          }
        }
      })
    },
    asyncGetPayment () {
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.findOneInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.id = resp.data.id
        }
        let _params = {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          membershipid: this.id,
          state: this.state
        }
        API.getPayment(_params).then(resp => {
          if (resp.resultCode === '0000') {
            this.tableData = resp.data.list
            this.total = resp.data.total
          }
        })
      })
    },
    addPayment () {
      this.$router.push('/notMemberEditPayment')
    }
  }
}
</script>

<style lang="scss" scoped>
.notMemberPaymentMain{
  .title {
    .text {
      margin-left: 0;
      color: #3778ff;
    }
    .blueCircle {
    vertical-align: middle;
    width: 30px;
    height: 30px;
    }
  }
}
</style>
